export const AccountDp = () => (
	<svg
		id="LogoDP_white"
		xmlns="http://www.w3.org/2000/svg"
		width="82.809"
		height="30"
		viewBox="-2 0 85 31.867"
	>
		<path
			id="Trazado_917"
			data-name="Trazado 917"
			d="M68.642,95.031a2.357,2.357,0,0,1,1.227-.34V97.23H69.2a1.821,1.821,0,0,0-1.154.3,1.289,1.289,0,0,0-.377,1.057v2.976H65.289V94.752H67.67v1.2a3.1,3.1,0,0,1,.972-.923"
			transform="translate(-48.004 -69.785)"
		/>
		<path
			id="Trazado_918"
			data-name="Trazado 918"
			d="M90.417,98.577H85.91a1.253,1.253,0,0,0,.309.832.947.947,0,0,0,.7.273.875.875,0,0,0,.85-.535h2.539a2.968,2.968,0,0,1-.614,1.258,3.158,3.158,0,0,1-1.148.868,3.64,3.64,0,0,1-1.531.316,3.7,3.7,0,0,1-1.792-.425A3.05,3.05,0,0,1,84,99.949a4.131,4.131,0,0,1-.006-3.711,3.029,3.029,0,0,1,1.221-1.209,4.055,4.055,0,0,1,3.59-.012A2.979,2.979,0,0,1,90.016,96.2a3.623,3.623,0,0,1,.437,1.816,4.22,4.22,0,0,1-.036.559m-2.393-1.154a.854.854,0,0,0-.292-.686,1.2,1.2,0,0,0-1.446-.012,1.15,1.15,0,0,0-.365.7Z"
			transform="translate(-61.226 -69.723)"
		/>
		<path
			id="Trazado_919"
			data-name="Trazado 919"
			d="M120.424,94.912l-1.737,6.815h-2.673l-.948-4.13-.984,4.13h-2.66L109.7,94.912h2.369l.765,4.519,1.009-4.519h2.551l1.045,4.531.753-4.531Z"
			transform="translate(-80.154 -69.945)"
		/>
		<path
			id="Trazado_920"
			data-name="Trazado 920"
			d="M150,96.243a2.909,2.909,0,0,1,1.045-1.215,2.677,2.677,0,0,1,1.476-.425,2.494,2.494,0,0,1,1.215.28,2.021,2.021,0,0,1,.79.753v-.948H156.9V101.5h-2.381v-.948a2.015,2.015,0,0,1-.8.753,2.5,2.5,0,0,1-1.209.28,2.675,2.675,0,0,1-1.476-.425A2.9,2.9,0,0,1,150,99.942a4.657,4.657,0,0,1,0-3.7m4.167.814a1.232,1.232,0,0,0-1.767-.006,1.447,1.447,0,0,0-.352,1.039,1.474,1.474,0,0,0,.352,1.039,1.154,1.154,0,0,0,.887.383,1.166,1.166,0,0,0,.88-.376,1.454,1.454,0,0,0,.359-1.045,1.438,1.438,0,0,0-.359-1.033"
			transform="translate(-109.053 -69.722)"
		/>
		<path
			id="Trazado_921"
			data-name="Trazado 921"
			d="M184.307,95.031a2.357,2.357,0,0,1,1.227-.34V97.23h-.668a1.822,1.822,0,0,0-1.154.3,1.289,1.289,0,0,0-.377,1.057v2.976h-2.381V94.752h2.381v1.2a3.1,3.1,0,0,1,.972-.923"
			transform="translate(-131.742 -69.785)"
		/>
		<path
			id="Trazado_922"
			data-name="Trazado 922"
			d="M199.6,90.763a2.891,2.891,0,0,1,1.051-1.215,2.7,2.7,0,0,1,1.482-.425,2.464,2.464,0,0,1,1.172.274,2.06,2.06,0,0,1,.808.747v-3.11h2.393v8.99h-2.393v-.948a2.03,2.03,0,0,1-.79.753,2.466,2.466,0,0,1-1.2.28,2.677,2.677,0,0,1-1.476-.425,2.9,2.9,0,0,1-1.044-1.221,4.658,4.658,0,0,1,0-3.7m4.167.814A1.232,1.232,0,0,0,202,91.571a1.448,1.448,0,0,0-.352,1.039A1.475,1.475,0,0,0,202,93.648a1.218,1.218,0,0,0,1.767.006,1.454,1.454,0,0,0,.359-1.045,1.437,1.437,0,0,0-.359-1.033"
			transform="translate(-144.964 -64.241)"
		/>
		<path
			id="Trazado_923"
			data-name="Trazado 923"
			d="M230.887,101.279a2.8,2.8,0,0,1-1.142-.85,2.2,2.2,0,0,1-.468-1.221h2.308a.731.731,0,0,0,.3.51,1.058,1.058,0,0,0,.632.182.782.782,0,0,0,.462-.121.373.373,0,0,0,.17-.316.4.4,0,0,0-.279-.376,5.735,5.735,0,0,0-.923-.267,8.018,8.018,0,0,1-1.215-.328,2.062,2.062,0,0,1-.844-.6,1.646,1.646,0,0,1-.359-1.118,1.936,1.936,0,0,1,.328-1.1,2.245,2.245,0,0,1,.965-.784,3.681,3.681,0,0,1,1.537-.292,3.124,3.124,0,0,1,2.1.656,2.566,2.566,0,0,1,.887,1.725H233.2a.8.8,0,0,0-.285-.5.952.952,0,0,0-.6-.176.756.756,0,0,0-.444.109.355.355,0,0,0-.152.3.4.4,0,0,0,.28.371,4.782,4.782,0,0,0,.9.261,7.971,7.971,0,0,1,1.233.352,2.2,2.2,0,0,1,.863.626,1.738,1.738,0,0,1,.37,1.172,1.766,1.766,0,0,1-.346,1.069,2.31,2.31,0,0,1-.984.747,3.787,3.787,0,0,1-1.5.273,4.152,4.152,0,0,1-1.646-.31"
			transform="translate(-166.727 -69.723)"
		/>
		<path
			id="Trazado_924"
			data-name="Trazado 924"
			d="M3.62,10.588A6.849,6.849,0,0,1,6.326,7.805a8.012,8.012,0,0,1,4.032-1,7.646,7.646,0,0,1,4.864,1.545,7.009,7.009,0,0,1,2.542,4.2H13.141a3.1,3.1,0,0,0-1.15-1.337,3.131,3.131,0,0,0-1.7-.46,2.938,2.938,0,0,0-2.377,1.063,4.284,4.284,0,0,0-.888,2.838,4.319,4.319,0,0,0,.888,2.86,2.938,2.938,0,0,0,2.377,1.063,3.131,3.131,0,0,0,1.7-.46,3.1,3.1,0,0,0,1.15-1.337h4.624a7.006,7.006,0,0,1-2.542,4.2,7.646,7.646,0,0,1-4.864,1.545,8.008,8.008,0,0,1-4.032-1A6.845,6.845,0,0,1,3.62,18.74a8.546,8.546,0,0,1-.953-4.087,8.5,8.5,0,0,1,.953-4.065"
			transform="translate(-2.667 -6.161)"
		/>
		<rect
			id="Rectángulo_5287"
			data-name="Rectángulo 5287"
			width="4.295"
			height="16.216"
			transform="translate(16.61 0.034)"
		/>
		<path
			id="Trazado_925"
			data-name="Trazado 925"
			d="M97.656,18.8V31.089H93.338V29.336a4.048,4.048,0,0,1-1.511,1.348,4.627,4.627,0,0,1-2.213.515,4.268,4.268,0,0,1-3.385-1.414,5.632,5.632,0,0,1-1.238-3.846V18.8h4.273v6.6a2.338,2.338,0,0,0,.559,1.654,2.129,2.129,0,0,0,2.969,0,2.367,2.367,0,0,0,.547-1.654V18.8Z"
			transform="translate(-62.267 -14.84)"
		/>
		<path
			id="Trazado_926"
			data-name="Trazado 926"
			d="M143.58,8.847a4.527,4.527,0,0,1,2.169-.493,4.829,4.829,0,0,1,2.663.767,5.258,5.258,0,0,1,1.884,2.191,7.557,7.557,0,0,1,.69,3.331,7.627,7.627,0,0,1-.69,3.342,5.24,5.24,0,0,1-1.884,2.2,4.823,4.823,0,0,1-2.663.767,4.529,4.529,0,0,1-2.169-.493,3.524,3.524,0,0,1-1.425-1.369V20.8h-4.3V4.585h4.3v5.632a3.524,3.524,0,0,1,1.425-1.369m2.4,3.922a2.21,2.21,0,0,0-3.177.011,2.591,2.591,0,0,0-.646,1.863,2.621,2.621,0,0,0,.646,1.884,2.186,2.186,0,0,0,3.177-.011,2.633,2.633,0,0,0,.646-1.874,2.586,2.586,0,0,0-.646-1.873"
			transform="translate(-100.543 -4.551)"
		/>
		<path
			id="Trazado_927"
			data-name="Trazado 927"
			d="M201.267,11.312a5.22,5.22,0,0,1,1.9-2.191,4.878,4.878,0,0,1,2.673-.767,4.449,4.449,0,0,1,2.115.493,3.7,3.7,0,0,1,1.457,1.348V4.585h4.317V20.8h-4.317V19.091a3.649,3.649,0,0,1-1.424,1.359,4.446,4.446,0,0,1-2.169.5,4.822,4.822,0,0,1-2.663-.767,5.23,5.23,0,0,1-1.884-2.2,7.623,7.623,0,0,1-.69-3.342,7.553,7.553,0,0,1,.69-3.331m7.516,1.468a2.223,2.223,0,0,0-3.189-.011,2.613,2.613,0,0,0-.635,1.873,2.662,2.662,0,0,0,.635,1.874,2.082,2.082,0,0,0,1.6.69,2.108,2.108,0,0,0,1.589-.679,2.624,2.624,0,0,0,.646-1.884,2.6,2.6,0,0,0-.646-1.863"
			transform="translate(-145.948 -4.551)"
		/>
		<path
			id="Trazado_928"
			data-name="Trazado 928"
			d="M260.835,18.744a4.449,4.449,0,0,1,2.169-.5,4.829,4.829,0,0,1,2.663.767,5.256,5.256,0,0,1,1.884,2.191,7.557,7.557,0,0,1,.69,3.331,7.627,7.627,0,0,1-.69,3.342,5.238,5.238,0,0,1-1.884,2.2A4.823,4.823,0,0,1,263,30.84a4.38,4.38,0,0,1-2.158-.5,3.831,3.831,0,0,1-1.435-1.359v7.582h-4.295V18.393h4.295V20.1a3.647,3.647,0,0,1,1.424-1.358m2.4,3.911a2.209,2.209,0,0,0-3.177.011,2.59,2.59,0,0,0-.647,1.863,2.62,2.62,0,0,0,.647,1.884,2.185,2.185,0,0,0,3.177-.011,2.633,2.633,0,0,0,.646-1.874,2.586,2.586,0,0,0-.646-1.873"
			transform="translate(-185.433 -14.437)"
		/>
		<path
			id="Trazado_929"
			data-name="Trazado 929"
			d="M253.516,4.48l4.228,1.935.679-1.952Z"
			transform="translate(-184.275 -4.463)"
			fill="#f82d28"
		/>
	</svg>
);
